/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Variable du tunnel (contexte tunnel) et son ouverture au valideur des devis.
 * @export
 * @interface TunnelVariableValideurDto
 */
export interface TunnelVariableValideurDto {
    /**
     * 
     * @type {string}
     * @memberof TunnelVariableValideurDto
     */
    variableValueId: string;
    /**
     * 
     * @type {string}
     * @memberof TunnelVariableValideurDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelVariableValideurDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TunnelVariableValideurDto
     */
    modifiableParValideur: boolean;
}

/**
 * Check if a given object implements the TunnelVariableValideurDto interface.
 */
export function instanceOfTunnelVariableValideurDto(value: object): value is TunnelVariableValideurDto {
    if (!('variableValueId' in value) || value['variableValueId'] === undefined) return false;
    if (!('modifiableParValideur' in value) || value['modifiableParValideur'] === undefined) return false;
    return true;
}

export function TunnelVariableValideurDtoFromJSON(json: any): TunnelVariableValideurDto {
    return TunnelVariableValideurDtoFromJSONTyped(json, false);
}

export function TunnelVariableValideurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TunnelVariableValideurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'modifiableParValideur': json['modifiableParValideur'],
    };
}

export function TunnelVariableValideurDtoToJSON(json: any): TunnelVariableValideurDto {
    return TunnelVariableValideurDtoToJSONTyped(json, false);
}

export function TunnelVariableValideurDtoToJSONTyped(value?: TunnelVariableValideurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'code': value['code'],
        'libelle': value['libelle'],
        'modifiableParValideur': value['modifiableParValideur'],
    };
}

